module.exports = __webpack_public_path__ + "8e3f16c2c0ff1ea9ef3bcda9c37f8c9e.MP3";